import { createAsyncThunk } from "@reduxjs/toolkit";

import { loadCategory } from "../../../api/products";
import { IProduct } from "../../../models/catalogue";
import { IProductCategoryID } from "../../../models/nominals";

/**
 * Loads products for a given category and filters them by availability.
 *
 * This thunk:
 * 1. Fetches all products in the specified category
 * 2. Filters products to only include those that are available to buy
 * 3. A product is considered available if either:
 *    - The parent product is available to buy, OR
 *    - At least one child variant is available to buy
 *
 * Used by ProductGrid component to load and display products for a category.
 */
export const loadProducts = createAsyncThunk(
    "productgrid2/loadProducts",
    async (productCategoryID: IProductCategoryID): Promise<IProduct[]> => {
        const products = await loadCategory(productCategoryID);

        // Filter to only include products with at least one available variant
        const availableProducts = products.filter((product) => {
            const availableParent = product.availability.is_available_to_buy;
            const availableChild = product.children.find(
                (child) => child.availability.is_available_to_buy,
            );
            return availableParent || availableChild;
        });

        return availableProducts;
    },
);
